import AccountingEntriesGroup from "./accounting-entries-group";

interface StoreExpense {
  id?: number;
  companyId?: number;
  storeId?: number;
  storeName?: string;
  userId?: number;
  userName?: string;
  expenseDate?: string;
  expenseType?: string;
  paymentMethod?: string;
  price?: number;
  description?: string;
  status?: string;
  revertDescription?: string;
  revertDate?: string;
  revertUserId?: number;
  revertUserName?: string;
  reverted?: boolean;
  hasLegalInvoice?: boolean;
  invoiceNumber?: string;
  supplierName?: string;
  supplierRuc?: string;
  attachmentUrl?: string;
  supplierId?: number;
  iva5?: number;
  iva10?: number;
  ivaExempt?: number;
  stamp?: string;
  accountingAccountId?: number;
  accountingAccountName?: string;
  accountingAccountCode?: string;
  expenseInvoiceType?: string;
  iva5Value?: number;
  iva10Value?: number;
  ivaExemptValue?: number;
  accountingGroupId?: number;
  accountingGroup?: AccountingEntriesGroup;
  addAccountToSupplier?: boolean;
}

export const newStoreExpense = (): StoreExpense => {
  return {};
};

export interface StatusData {
  class: string;
  name: string;
}

interface StatusesMap {
  [index: string]: StatusData;
}

export const STOREEXPENSESTATUSES: StatusesMap = {
  registered: {
    class: "success",
    name: "Registrado",
  },
  reverted: {
    class: "danger",
    name: "Revertido",
  },
};

export const getStoreExpenseStatusLabel = (key: string) => {
  return STOREEXPENSESTATUSES[key].name;
};

export const getStoreExpenseStatusClass = (key: string) => {
  return STOREEXPENSESTATUSES[key].class;
};

export const STOREEXPENSETYPES: StatusesMap = {
  in_store: {
    class: "info",
    name: "Registrado en tienda",
  },
  in_factory: {
    class: "info",
    name: "Registrado en fábrica",
  },
};

export const getStoreExpenseTypeLabel = (key: string) => {
  return STOREEXPENSETYPES[key].name;
};

export const getStoreExpenseTypeClass = (key: string) => {
  return STOREEXPENSETYPES[key].class;
};

export const STOREEXPENSEMETHODS: { [key: string]: string } = {
  cash: "Efectivo",
  transfer: "Transferencia",
};

export const getStoreExpenseMethodLabel = (key: string) => {
  return STOREEXPENSEMETHODS[key];
};

export const getStoreExpenseMethodClass = (key: string) => {
  return STOREEXPENSEMETHODS[key];
};

export default StoreExpense;
